import { render, staticRenderFns } from "./ScoopHeader.vue?vue&type=template&id=4d6d278a&scoped=true&"
import script from "./ScoopHeader.vue?vue&type=script&lang=js&"
export * from "./ScoopHeader.vue?vue&type=script&lang=js&"
import style0 from "./ScoopHeader.vue?vue&type=style&index=0&id=4d6d278a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6d278a",
  null
  
)

export default component.exports